import React from "react";
import { Box, Flex, keyframes, Spinner } from "@chakra-ui/react";
import { Focus } from "src/hooks/useElementFocus";

const blink = keyframes`
  50% {
    opacity: 0.0;
  }
`;

export default class CodeInput extends React.Component {
  onChange = (e) => {
    const { onChange } = this.props;
    const code = e.target.value.toString();
    if (code.length === 10) {
      return;
    }
    onChange(code);
  };

  renderFields() {
    const { code } = this.props;
    const fieldsList = [];
    for (let i = 0; i < 9; i++) {
      fieldsList.push(
        <Flex
          key={i}
          justifyContent="center"
          alignItems="flex-end"
          width="18px"
          mr={i === 2 || i === 5 ? "6px" : "0px"}
          sx={{
            ".active": {
              animation: `${blink} 1s step-start 0s infinite`,
              bg: "primary"
            }
          }}
        >
          {typeof code[i] === "string" ? (
            <Flex
              as="span"
              color="primary"
              fontSize="26px"
              fontWeight="bold"
              fontStyle="normal"
              fontStretch="normal"
              lineHeight="1.23"
              letterSpacing="0.4px"
              textAlign="center"
            >
              {code[i]}
            </Flex>
          ) : (
            <Box
              as="span"
              bg="#d8d8d8"
              borderRadius="16px"
              height="3px"
              mb="6px"
              width="12px"
              className={code.length === i ? "active" : undefined}
            />
          )}
        </Flex>
      );
    }
    return fieldsList;
  }

  render() {
    const { processing, code } = this.props;
    return (
      <label htmlFor="code-input">
        <Flex height="32px" alignItems="flex-end">
          {processing ? <Spinner /> : this.renderFields()}
        </Flex>
        <Box
          ref={Focus.addElement}
          border="0"
          padding="0"
          margin="0"
          width="0"
          height="0"
          as="input"
          type="number"
          onChange={this.onChange}
          id="code-input"
          value={code}
        />
      </label>
    );
  }
}
